<template>
  <li>
    <div class="row">
      <div class="col-xs-3">
        <div class="avatar">
          <img
            src="img/Friends/woman-2.jpg"
            alt="img"
            class="img-circle img-no-padding img-responsive"
          />
        </div>
      </div>
      <div class="col-xs-9">
        <b><a href="#">Hillary Markston</a></b> shared a
        <b><a href="#">publication</a></b
        >.
        <span class="timeago">5 min ago</span>
      </div>
    </div>
  </li>
</template>